import React from 'react';
import { useTranslation } from 'react-i18next';
import { GoodwillForm, CompensationForm } from '../components/Sales/avoir/GoodwillForms';
import { Emo, emoText } from './EmojiIcons';
import DrawerHeader from './drawer/DrawerHeader';
import useActionLabel from '../i18n/useActionLabel';

// Phase 3 drawers in the + Create host (twins of CreditNoteDoorForm). Params: { partnerId, partnerName } (opened from the customer page only).
const Head = ({ size, onSize, onClose, icon, action }) => {
  const { t } = useTranslation('avoir'); const al = useActionLabel();
  return <DrawerHeader eyebrow={t('gw.eyebrow')} ini={<Emo name={icon} />} title={emoText(al(action))} size={size} onSize={onSize} onClose={onClose} />;
};
const make = (Form, icon, action) => function Door({ size, onSize, onClose, onInteract, params }) {
  const p = params || {};
  return (<><Head size={size} onSize={onSize} onClose={onClose} icon={icon} action={action} /><Form partnerId={p.partnerId || ''} partnerName={p.partnerName || ''} onClose={onClose} onInteract={onInteract} /></>);
};
export const GoodwillCreateForm = make(GoodwillForm, 'discount', 'issueGoodwill');
export const CompensationCreateForm = make(CompensationForm, 'money', 'recordCompensation');
